module.exports = __webpack_public_path__ + "static/media/icon-mail.f3cfd0cb.svg";